import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent {
  @Input() label: string = 'Click here to upload Files';
  @Input() accept: string = '*';
  @Input() fileName: string = '';
  @Input() invalid: boolean = false;
  @Input() disabled: boolean = false;
  @Input() baseUrl: string = '';
  @Input() uploadUrl: string = '';

  @Output() fileSelected = new EventEmitter<{ file: File, event: Event }>();

  private static readonly categoryExtensions: { [category: string]: string[] } = {
    'image/': ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.heic', '.heif'],
    'video/': ['.mp4', '.avi', '.mov', '.wmv', '.mkv', '.webm'],
  };

  private isAllowedFile(file: File): boolean {
    if (!file) {
      return false;
    }
    if (!this.accept || this.accept === '*') {
      return true;
    }

    const fileName = file.name?.toLowerCase() ?? '';
    const extension = '.' + (fileName.split('.').pop() ?? '');

    return this.accept.split(',').some(rule => {
      rule = rule.trim().toLowerCase();
      if (!rule) {
        return false;
      }
      if (rule.startsWith('.')) {
        return extension === rule;
      }
      if (rule.endsWith('/*')) {
        const category = rule.slice(0, -1);
        // file.type can be empty for some browsers/OS (e.g. HEIC images),
        // so fall back to checking the extension against a known list.
        return file.type.startsWith(category)
          || (!file.type && (FileUploaderComponent.categoryExtensions[category] ?? []).includes(extension));
      }
      return file.type === rule;
    });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (!this.isAllowedFile(file)) {
        input.value = '';
        return;
      }

      this.fileSelected.emit({ file, event });
    }
  }
}
